<template>
  <form
    class="bg-white mx-auto w-full max-w-xs shadow-md rounded z-30 px-8 py-6"
    @submit.prevent>
    <div class="mb-4">
      <label
        class="block text-gray-700 text-sm font-bold mb-2"
        for="email">
        E-mail
      </label>
      <input
        id="email"
        v-model="email"
        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
        type="email">
    </div>
    <div class="mb-6">
      <label
        class="block text-gray-700 text-sm font-bold mb-2"
        for="password">
        Password
      </label>
      <input
        id="password"
        v-model="password"
        :class="{ 'border-red-500': emailError || passwordError }"
        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
        type="password"
        @focus="resetErrors()">
      <template v-if="emailError || passwordError">
        <p
          v-for="(message, i) in emailErrorMessage"
          :key="i"
          class="text-red-500 text-xs italic">
          {{ message }}
        </p>
      </template>
    </div>
    <div class="flex items-center justify-between mb-6">
      <button
        :disabled="$store.state.loading"
        class="bg-blue-700 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none disabled:opacity-75 disabled:cursor-not-allowed"
        @click.stop="login()">
        Masuk
      </button>
      <a
        class="inline-block align-baseline font-bold text-sm text-blue-700 hover:text-blue-700"
        href="/password/reset">
        Lupa Password?
      </a>
    </div>
    <div class="text-xs text-center">
      Belum punya akun?
      <a
        class="inline-block align-baseline font-bold text-blue-700 hover:text-blue-700"
        href="/register">
        Yuk Daftar
      </a>
    </div>
  </form>
</template>

<script>
export default {
  data: function() {
    return {
      email: '',
      password: '',
      errors: {},
    };
  },
  computed: {
    emailError: function() {
      return 'email' in this.errors;
    },
    emailErrorMessage: function() {
      return this.errors.email;
    },
    passwordError: function() {
      return 'password' in this.errors;
    },
    passwordErrorMessage: function() {
      return this.errors.password;
    },
  },
  methods: {
    resetErrors: function() {
      this.errors = {};
    },
    async login() {
      this.$store.commit('setLoading', true);
      try {
        var response = await axios.post('/login', {
          email: this.email,
          password: this.password
        });

        if (response.data.data != undefined) {
          this.$store.commit('shouldAuth', false);
          this.$store.commit('setUser', response.data.data);
        }

        if (this.$store.state.pendingAction != null && this.$store.state.pendingAction.type == 'addToCart') {
          await this.$store.dispatch('continueAction');
          window.location.href = '/cart';
        } else {
          window.location.href = '/profile';
        }
      } catch(error) {
        this.$store.commit('setLoading', false);
        this.handleError(error);
      }
      this.$store.commit('setLoading', false);
    },
    handleError: function (error) {
      if (error.response.status == 422) {
        if (error.response.data && error.response.data.errors) {
          this.errors = error.response.data.errors;
          return;
        }
      } else {
        throw error;
      }
    },
  },
}
</script>
